<template>
  <footer class="shell-footer">
    <v-sheet
      min-height="500px"
      class="relative map-contact grey lighten-1 d-flex align-center"
    >
      <div v-if="!smAndDown" class="iframe-content">
        <div class="iframe-content-container" v-html="informations.map"></div>
      </div>
      <v-container>
        <v-row justify="center" justify-md="end">
          <v-col class="pt-12 pt-sm-8 pt-lg-5" cols="12" md="5">
            <ContactSection />
          </v-col>
          <v-col class="pa-0 mt-10 mt-sm-0" cols="12">
            <div v-if="smAndDown" v-html="informations.map"></div>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <v-sheet color="primary" class="position-relative">
      <v-container class="py-10">
        <v-row class="justify-sm-space-between" no-gutters>
          <v-col class="mb-10 mb-md-0" cols="12" md="3">
            <router-link to="/">
              <img
                v-if="informations.img"
                src="../../assets/img/logo-white-bg.svg"
                :height="smAndDown ? `100px` : `125px`"
                class="d-block mx-auto mx-md-0"
              />
            </router-link>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <div class="font-weight-medium text-subtitle-1 white--text">
              Institucional
            </div>
            <div
              class="
                d-flex
                flex-column
                align-start
                mt-4
                shell-footer-institucional
              "
            >
              <v-btn
                v-for="({ text, to }, keyMenu) in menuFooter"
                :key="keyMenu"
                text
                active-class="nav-link-active"
                class="
                  text-none
                  mx-n4
                  rounded-0
                  shell-footer-institucional-item
                  nav-link
                "
                v-bind="getLinkAttrs(to)"
              >
                <v-icon size="16" color="secondary"
                  >fas fa-chevron-right</v-icon
                >
                <span class="white--text ml-3 grey--text text-caption">{{
                  text
                }}</span>
              </v-btn>
            </div>
          </v-col>
          <v-col class="mt-10 mt-sm-0" cols="12" sm="6" md="5">
            <div class="font-weight-medium text-subtitle-1 white--text">
              Produtos
            </div>
            <div class="shell-footer-products d-flex flex-wrap mt-4">
              <router-link
                v-for="({ text, to }, i) in categories"
                :key="i"
                text
                active-class="nav-link-active"
                class="
                  text-none
                  px-0
                  rounded-0
                  shell-footer-products-item
                  nav-link
                "
                :to="to"
              >
                <div class="d-flex align-center">
                  <v-icon size="16" color="secondary"
                    >fas fa-chevron-right</v-icon
                  >
                  <span class="white--text ml-3 grey--text text-caption">{{
                    text
                  }}</span>
                </div>
              </router-link>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>

    <v-sheet class="py-4" color="secondary">
      <v-container
        class="
          py-0
          d-flex
          flex-column flex-sm-row
          justify-space-between
          align-center
          text-center
        "
      >
        <div class="primary--text text-caption">
          <b class="font-weight-bold"> {{ informations.short_name }}</b> ©
          {{ year }}
          <span class="d-block d-sm-inline-block">
            Todos os direitos reservados
          </span>
        </div>
        <a
          class="d-flex mt-4 mt-sm-0"
          href="https://www.mrxweb.com.br/"
          target="_blank"
        >
          <img
            class="shell-footer-logo"
            src="../../assets/img/mrxweb.svg"
            alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            height="20px"
          />
        </a>
      </v-container>
    </v-sheet>
  </footer>
</template>

<script>
import { getContact } from "../../utils/getContact";
import { menuFooter } from "../../config";
import { formatToURL } from "../../utils/formatToURL";
import { getSocial } from "../../utils/getSocial";
import ContactSection from "../sections/ContactSection.vue";
import { getLinkAttrs } from "../../utils/getLinkAttrs";

export default {
  data: () => ({
    year: new Date().getFullYear(),
    menuFooter,
  }),
  computed: {
    categories() {
      return this.$rest("categories").list.map(({ title }) => {
        return {
          to: `/produtos/${formatToURL(title)}`,
          text: title,
        };
      });
    },
    menuFooterArray() {
      return Array.from(this.menuFooter(this.menu));
    },
    informations() {
      return this.$rest("informations").item;
    },
    contacts() {
      return getContact(this.informations);
    },
    social() {
      return getSocial(this.informations);
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getLinkAttrs,
  },
  components: {
    ContactSection,
  },
};
</script>

<style lang="scss">
.shell-footer {
  .nav-link {
    &:before {
      opacity: 0 !important;
    }
  }

  .nav-link-active span {
    color: #fff !important;
    background-color: transparent !important;
    font-weight: 600;
  }
}
.iframe-content {
  width: 50%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  &-container {
    height: 100%;
    width: 100%;
  }
}
.shell-footer iframe {
  width: 100% !important;
  height: 100% !important;
  min-height: 300px;
  display: block !important;
}
</style>

<style lang="scss" scoped>
.shell-footer {
  &-institucional-item {
    cursor: pointer !important;
  }

  &-institucional-item span {
    transition: all 0.2s ease;
  }

  &-institucional-item:hover span {
    color: #fff !important;
  }

  &-products {
    gap: 15px 30px;

    &-item {
      width: 180px;
      cursor: pointer !important;

      & span {
        transition: all 0.2s ease;
      }

      &:hover span {
        color: #fff !important;
      }
    }
  }
}
</style>
